import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { off, on, trigger } from '../../Utils/events';
import style from './off-canvas.module.scss';
import { CosmosButton, CosmosIconClose, CosmosMode } from '../../cosmos/web-scoped/react';

const OffCanvas = ({ id, group = '', children, topOffset = 0 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // listen to component switch events
    on(`offCanvasOpen-${id}`, open);
    if (group.length) {
      on(`offCanvasClose-g-${group}`, close);
    }
    return () => {
      off(`offCanvasOpen-${id}`, open);
      off(`offCanvasClose-g-${group}`, open);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const open = (data) => {
    // close other group elements before opening
    if (data.detail.group && group.length) {
      trigger(`offCanvasClose-g-${data.detail.group}`, {});
    }
    setShow(true);
  }
  const close = () => setShow(false);

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        {show &&
          <CosmosMode mode="light">
            <motion.div
              className={style.offCanvas}
              initial={{ top: (topOffset - 100) + 'px', opacity: 0 }}
              animate={{ top: topOffset, opacity: 1 }}
              exit={{ top: (topOffset - 100) + 'px', opacity: 0 }}>
              <div>
                <div className="offcanvas__header">
                  <CosmosButton
                    class={`offcanvas__close`}
                    onClick={() => setShow(false)}
                    kind="bare"
                    shape="circle">
                    <CosmosIconClose slot="icon" style={{ width: "20px", height: "20px" }} />
                  </CosmosButton>
                </div>
                <div className="offcanvas__body">
                  {children}
                </div>
              </div>
            </motion.div>
          </CosmosMode>
        }
      </AnimatePresence>
    </>
  );
};

export { OffCanvas };
